import { Component, inject } from '@angular/core';
import {
  RdsDialogModule,
  RdsButtonModule,
  RDS_DIALOG_DATA,
  RdsIconsModule,
  RdsDialogRef,
} from '@rds/angular-components';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'inexp-alert-dialog',
  imports: [RdsDialogModule, RdsButtonModule, RdsIconsModule, RouterModule],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
})
export class AlertDialogComponent {
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    title: string;
    description: string;
    icon: string;
    iconColor: string;
    navigation?: string;
    buttonConfirm?: string;
    buttonClose?: string;
  };

  private readonly _dialogRef = inject(RdsDialogRef);
  private readonly _router = inject(Router);

  navigateAndClose() {
    if (this.data.navigation) {
      this._dialogRef.close();
      setTimeout(() => {
        this._router.navigate([this.data.navigation]).then(() => {
          window.scrollTo({ top: 0, behavior: 'instant' });
        });
      }, 200);
    }
  }
}
